import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=7202cf22&scoped=true&functional=true&"
import script from "./PageSection.vue?vue&type=script&lang=js&"
export * from "./PageSection.vue?vue&type=script&lang=js&"
import style0 from "./PageSection.vue?vue&type=style&index=0&id=7202cf22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7202cf22",
  null
  
)

export default component.exports